import { Fragment } from "react";
import { createPortal } from "react-dom";
import Cells from "./Cells/Cells";
import FlotteRowDetailModal from "./FlotteRowDetailModal";
import { StickyIdentiteCell } from "./StickyIdentite";
import styles from "./FlotteTable.module.scss";
import useFlotte from "../../hooks/useFlotte";

const FlotteTableRow = ({
  item,
  rowRef,
  visibleHeaders,
  onMouseEnter,
  onMouseLeave,
  isRowSelected,
  toggleRowSelection,
  isDetailActive,
  isModalOpen,
  onOpenDetail,
  onCloseModal,
  stickyIdentite,
}) => {
  const { actions } = useFlotte();

  const onClickShowDetail = () => {
    onOpenDetail(item.id);
  };

  return (
    <>
      <tr
        key={item.id}
        ref={rowRef}
        onDoubleClick={() => onClickShowDetail()}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={isDetailActive ? styles.detailActiveRow : undefined}
      >
        {Object.keys(visibleHeaders).map((header) => {
          if (!visibleHeaders[header]) return null;
          return (
            <Fragment key={header}>
              <Cells
                type={header}
                toggle={() => onClickShowDetail()}
                item={item}
                isOpen={isModalOpen}
                isRowSelected={isRowSelected}
                toggleRowSelection={toggleRowSelection}
                onUpdateCell={(field, newValue) =>
                  actions.onUpdateCell(item, field, newValue)
                }
                onDeverrouillerFacturation={actions.onDeverrouillerFacturation}
              />
              {/* Colonne de synthèse figée (LS-707), juste après la colonne
                  de sélection ("actions", jamais masquable) */}
              {header === "actions" && stickyIdentite && (
                <StickyIdentiteCell item={item} />
              )}
            </Fragment>
          );
        })}
      </tr>
      {isModalOpen &&
        createPortal(
          <div
            className="position-fixed w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              top: 0,
              left: 0,
              background: "rgba(0, 0, 0, 0.54)",
              zIndex: 99,
              overflowY: "auto",
            }}
            onClick={onCloseModal}
          >
            <div
              className="position-fixed bg-white p-5 animated zoomIn faster"
              style={{
                zIndex: 99,
                top: 0,
                width: "94%",
                height: "97%",
                overflowY: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <FlotteRowDetailModal
                item={item}
                visibleHeaders={visibleHeaders}
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  padding: 10,
                }}
              >
                <button
                  onClick={onCloseModal}
                  className="btn btn-default bg-white"
                >
                  <i className="fa fa-times" />
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default FlotteTableRow;
